
import commaNumber from 'comma-number'
import analytics from '@/helpers/analytics'
import { partnerLineDisplay, itemDisplayAmountAndSymbol } from '@/helpers/currencyDisplay'

export default {
  components: {
    DropdownCompareItem: () => import('@/components/DropdownCompareItem'),
    DropdownPartnerItem: () => import('@/components/DropdownPartnerItem')
  },
  props: {
    expiredPartners: {
      type: Number,
      required: false,
      default: 0
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      expandList: false,
      maxItemsPreview: 3
    }
  },
  computed: {
    isHotels () {
      return this.$store.state.siteType === 'hotels'
    },
    hasItems () {
      return this.items.length > 0
    },
    previewItems () {
      return this.items.slice(0, this.maxItemsPreview)
    },
    showCompareAll () {
      return this.items.some(item => this.isCompareItem(item))
    },
    offersTextClasses () {
      return this.isHotels ? 'hidden md:inline' : 'md:hidden'
    }
  },
  methods: {
    isExpired (index) {
      // If expiredPartners is 0, nothing is expired
      if (!this.expiredPartners) return false
      return index >= this.items.length - this.expiredPartners
    },
    isCompareItem(item) {
      return item.component === 'DropdownCompareItem'
    },
    toggleExpandList() {
      if (!this.expandList) {
        const eventName = 'dropdown-expand'
        analytics.track(eventName, this)
        console.info('Expand list')
      }
      this.expandList = !this.expandList
    },
    partnerClick(item) {
      this.$emit('partnerClick', item)
    },
    openDeeplinkUrl(index) {
      const isCompareItem = this.isCompareItem(this.items[index]);
      const event = isCompareItem ? 'preview-dropdown-compare-click' : 'preview-dropdown-pricelink-click'
      const itemType = isCompareItem ? 'compare' : 'partner'
      const deeplinkUrl = isCompareItem ? this.items[index].deepLink : this.items[index].partnerDeeplinkUrl

      if (!isCompareItem) {
        this.$emit('partnerClick', this.items[index])
      }

      analytics.track(event, this)
      console.info(`Open ${itemType} deeplink URL`)
      window.newTab = window.open(deeplinkUrl, '_blank')
    },
    compareAll() {
      const eventName = 'dropdown-compare-all-click-flight'
      analytics.track(eventName, this)
      this.$emit('compareAll')
    },
    previewLine (item) {
      const state = this.$store.state
      const ui = this.isHotels
        ? partnerLineDisplay(item, state)
        : itemDisplayAmountAndSymbol(item, state)
      return `${ui.symbol}${commaNumber(Math.round(ui.amount))}`
    }
  }
}
